import { ReactNode, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { APP_BAR_ID } from '../../routes/routes-page.styles';

export const modalRootId = 'dynamic-modal-root';

let setModalGlobal: (modal: ReactNode | null) => void;

function findPortalContainer(modalRootId: string) {
  const portalContainer = document.getElementById(modalRootId);

  if (!portalContainer) {
    const portalContainer = document.createElement('div');
    portalContainer.id = modalRootId;
    document.body.appendChild(portalContainer);

    return portalContainer;
  }

  return portalContainer;
}

export function renderRootModal(node: ReactNode) {
  if (!setModalGlobal) {
    throw new Error('modalRoot is not mounted');
  }
  setModalGlobal(node);
}

const ModalRoot = () => {
  const [modal, setModal] = useState<ReactNode | null>(null);
  const modalRootRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    setModalGlobal = setModal;

    const portalContainer = findPortalContainer(modalRootId);

    modalRootRef.current = portalContainer;

    return () => {
      setModalGlobal = () => null;
      if (modalRootRef.current && modalRootRef.current.parentNode) {
        modalRootRef.current.parentNode.removeChild(modalRootRef.current);
      }

      try {
        const appBarEl = document.getElementById(APP_BAR_ID);
        if (appBarEl) {
          appBarEl.style.visibility = appBarEl.dataset.prevVisibility ?? '';
          delete appBarEl.dataset.prevVisibility;
        }
      } catch {
        /* ignore */
      }
    };
  }, []);

  useEffect(() => {
    try {
      const appBarEl = document.getElementById(APP_BAR_ID);
      if (!appBarEl) {
        return;
      }

      if (modal) {
        if (appBarEl.dataset.prevVisibility === undefined) {
          appBarEl.dataset.prevVisibility = appBarEl.style.visibility || '';
        }

        appBarEl.style.visibility = 'hidden';
      } else {
        const prev = appBarEl.dataset.prevVisibility;
        appBarEl.style.visibility = prev ?? '';
        delete appBarEl.dataset.prevVisibility;
      }
    } catch {
      // ignore DOM errors
    }
  }, [modal]);

  if (!modal || !modalRootRef.current) {
    return null;
  }

  return createPortal(modal, modalRootRef.current);
};

export default ModalRoot;
